import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IntegrationModule } from './store/integration/integration.module'

@NgModule({
  imports: [CommonModule, IntegrationModule],
})
export class IntegrationLibModule {}
